const state = {
  cartItems: JSON.parse(localStorage.getItem('cartItems') || '[]')
}

const mutations = {
  ADD_TO_CART(state, product) {
    const existingItem = state.cartItems.find(item => item.id === product.id)
    
    if (existingItem) {
      existingItem.quantity += 1
    } else {
      state.cartItems.push({
        ...product,
        quantity: 1
      })
    }
    
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
  },
  
  REMOVE_FROM_CART(state, productId) {
    state.cartItems = state.cartItems.filter(item => item.id !== productId)
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
  },
  
  UPDATE_QUANTITY(state, { productId, quantity }) {
    const item = state.cartItems.find(item => item.id === productId)
    if (item) {
      item.quantity = quantity
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
    }
  },
  
  CLEAR_CART(state) {
    state.cartItems = []
    localStorage.removeItem('cartItems')
  }
}

const actions = {
  addToCart({ commit }, product) {
    commit('ADD_TO_CART', product)
  },
  
  removeFromCart({ commit }, productId) {
    commit('REMOVE_FROM_CART', productId)
  },
  
  updateQuantity({ commit }, payload) {
    commit('UPDATE_QUANTITY', payload)
  },
  
  clearCart({ commit }) {
    commit('CLEAR_CART')
  }
}

const getters = {
  cartItems: state => state.cartItems,
  cartCount: state => state.cartItems.reduce((total, item) => total + item.quantity, 0),
  cartTotal: state => state.cartItems.reduce((total, item) => total + item.price * item.quantity, 0)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
